// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-TransactionsList-styles___controlsContainer--XOLKA {
    display: flex;
    justify-content: space-between;
}

.components-TransactionsList-styles___filtersWrapper--PIwyU {
    flex: 1;
}

.components-TransactionsList-styles___actionsContainer--kRVkp {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./components/TransactionsList/styles.pcss"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB","sourcesContent":[".controlsContainer {\n    display: flex;\n    justify-content: space-between;\n}\n\n.filtersWrapper {\n    flex: 1;\n}\n\n.actionsContainer {\n    display: flex;\n    gap: 8px;\n    flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controlsContainer": `components-TransactionsList-styles___controlsContainer--XOLKA`,
	"filtersWrapper": `components-TransactionsList-styles___filtersWrapper--PIwyU`,
	"actionsContainer": `components-TransactionsList-styles___actionsContainer--kRVkp`
};
module.exports = ___CSS_LOADER_EXPORT___;
